<template>
	<div class="confirm">
		<div>
			<div class="header5">Hello!</div>
			<div class="header3">Please confirm your information</div>
		</div>
		<div v-if="filingOption" class="confirm-option">
			You have selected to {{ filingOption == 1 ? " file on your own " : " have Garbur file on your behalf " }}
			<!-- <span v-if="filingOption == 1"> file on your own &nbsp;</span>
				<span v-if="filingOption == 2"> have Garbur file on your behalf </span> -->
			<span @click="switchFilingOption" class="change-option"> change option</span>
		</div>
		<OrderForm :isConfirm="true" />
		<div v-if="hasExistingOrderMessage != ''">
			<span>{{ hasExistingOrderMessage }} Confirm if you would like to continue.</span>
		</div>
		<div class="button-cont">
			<Button v-if="!isEdit" title="Edit User Information" buttonType="outline" :onClick="editRegisterForm" />
			<Button v-if="isEdit" title="Save" :onClick="updateRegister" />
			<Button v-if="!isEdit" title="Confirm" :onClick="confirm" />
			<Button v-if="hasExistingCase.status == 1" title="Go to Case Page" :onClick="goCasePage" />
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import OrderForm from "@/components/account/OrderForm.vue";
import { AUTH_REGISTER } from "../store/constants";
import localData from "@/store/utils/localdata";
import Button from "@/components/ui/Button.vue";
// https://github.com/mariomka/vue-datetime
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import api from "@/store/utils/api";

export default {
	name: "confirm",
	title: "Confirm",
	components: {
		OrderForm,
		Button,
	},
	data() {
		return {
			sendEmail: false,
			propertyId: 0,
			filingOption: null,
			hasExistingCase: {
				caseId: 0,
				status: 0,
			},
		};
	},
	mounted() {
		window.scrollTo(0, 0);

		this.$store.dispatch("getConfirmPageData", { id: this.$route.query.pid }).then((data) => {
			this.$store.commit("setOrderForm", {
				firstName: data.firstName,
				lastName: data.lastName,
				email: data.email,
				phone: data.phone,
				password: "",
				address: data.address,
				pin: data.pin,
				homePurchased: !!this.$route.query.purchaseAmount ? "Yes" : "No",
				purchaseDate: this.$route.query.purchaseDate,
				purchaseAmount: this.$route.query.purchaseAmount,
			});
			this.hasExistingCase.status = data.hasExistingOrder.status;
			this.hasExistingCase.caseId = data.hasExistingOrder.orderId;
		});
		this.filingOption = this.$route.query.filingOption ?? localData.getItem("activePlanValue"); //need the localData if user was stayed logged in.
	},
	methods: {
		validate(user) {
			if (!user.email) {
				return {
					isValid: false,
					message: "Email is required",
				};
			}
			return {
				isValid: true,
			};
		},
		async submit() {
			const user = {
				firstName: this.firstName,
				lastName: this.lastName,
				email: this.email,
				phone: this.phone,
				password: this.password,
				// propertyId: this.currentData.propertyId,
				filingOption: this.filingOption,
				// address: this.address,
				pin: this.pin,
				// homePurchased: this.homePurchased === "Yes",
				purchaseDate: this.purchaseDate,
				purchaseAmount: this.purchaseAmount,
			};
			const validation = this.validate(user);
			if (!validation.isValid) {
				this.$toast.open({
					message: validation.message,
					position: "top",
					type: "error",
				});
				return;
			}

			try {
				const results = await this.$store.dispatch(AUTH_REGISTER, user);
				this.showEmailMessage();
			} catch (ex) {
				this.$toast.open({
					message: `Unable to register. ${ex.msg}`,
					position: "top",
					type: "error",
				});
			}
		},
		editRegisterForm() {
			this.$store.commit("setOrderFormEditable", true);
		},
		clear() {
			document.getElementById("register").reset();
		},
		goCasePage() {
			this.$router.push({ name: "Case", params: { id: this.hasExistingCase.caseId } });
			//this.$router.push(`/case/${this.$route.params.id}`);
		},
		// goPayment() {
		// 	this.$router.push({ name: "Payment" });
		// },
		async confirm() {
			const userData = {
				firstName: this.formData.firstName,
				lastName: this.formData.lastName,
				email: this.formData.email,
				phone: this.formData.phone,
				propertyId: this.currentData.propertyId,
				filingOption: this.filingOption,
				// address: this.address,
				pin: this.formData.pin,
				// homePurchased: this.homePurchased === "Yes",
				purchaseDate: this.formData.purchaseDate,
				purchaseAmount: this.formData.purchaseAmount,
			};
			try {
				const order = await api.post("/api/v1/orders/confirm", userData);
				// this.$router.push({ name: "Payment", params: { id: order.id } });
				// @TODO need to ask about caseID and run locally or case.id
				// this.$router.push({ name: "Case", params: { id: caseId } });
				this.$router.push({ name: "Case", params: { id: order.id } });
			} catch (ex) {
				this.$toast.open({
					message: `Unable to confirm. ${ex.msg}`,
					position: "top",
					type: "error",
				});
			}
		},
		showEmailMessage() {
			this.sendEmail = true;
		},
		switchFilingOption() {
			this.$router.push(`file-options/${this.currentData.propertyId}`);
		},
		async updateRegister() {
			const userData = {
				firstName: this.formData.firstName,
				lastName: this.formData.lastName,
				email: this.formData.email,
				phone: this.formData.phone,
				propertyId: this.currentData.propertyId,
			};
			console.log("userData", userData, this.formData);
			try {
				const order = await api.post("/api/v1/orders/confirm-update-user", userData);
			} catch (ex) {
				this.$toast.open({
					message: `Unable to edit. ${ex.msg}`,
					position: "top",
					type: "error",
				});
			}
			this.$store.commit("setOrderFormEditable", false);
		},
	},
	computed: {
		property() {
			return this.$store.getters.getAllPropertyData;
		},
		currentData() {
			return JSON.parse(localData.getItem("currentData"));
		},
		isEdit() {
			return this.$store.getters.getOrderFormEditable;
		},
		formData() {
			return this.$store.getters.getOrderForm;
		},
		hasExistingOrderMessage() {
			if (this.hasExistingCase.status == 1) return "You have an existing case for this property. Had to your account to see existing cases.";
			if (this.hasExistingCase.status == 2) return "Someone has started a case for this property";
			return "";
		},
	},
};
</script>

<style scoped lang="scss">
.confirm {
	text-align: left;
	display: flex;
	flex-direction: column;
	padding: 65px 60px;
	max-width: 1650px;
	.header5 {
		color: var(--accent);
	}
	.header3 {
		font-size: 36px;
		line-height: 36px;
		color: var(--black);
		margin-top: 8px;
	}

	span.change-option {
		margin-left: 6px;
		cursor: pointer;
		color: rgba(80, 205, 243, 1);
	}
	span.change-option:hover {
		color: var(--primary);
		// opacity: 1 !important;
	}

	.confirm-option {
		display: flex;
		margin-top: 25px;
	}
	.button-cont {
		display: flex;
		flex-direction: row;
		// margin-top: 55px;
		.button {
			margin: 0 10px;
		}
	}
}
@media (max-width: 414px) {
	.confirm {
		padding: 3rem 1rem;
		.confirm-option {
			display: flex;
			flex-direction: column;
		}
	}
}
</style>
